module.exports = __webpack_public_path__ + "static/media/verified.5031ac72.png";